import type { JSX } from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';
import { cn } from '@/lib/utils';

import { ALERT_ACTION_CATALOG, getAlertActionDefinition } from '../../types/alertsConfig';
import AlertActionBadge from './AlertActionBadge';

interface AlertActionSelectProps {
  id: string;
  value: string;
  onChange: (fn: string) => void;
}

const AlertActionSelect = ({ id, value, onChange }: AlertActionSelectProps): JSX.Element => {
  const currentDef = value ? getAlertActionDefinition(value) : undefined;

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger id={id} className="h-10 w-full px-4 py-2">
        <span className={cn('truncate', !value && 'text-text-subtle')}>
          {currentDef?.label ?? (value || 'Selecciona una acción…')}
        </span>
      </SelectTrigger>
      <SelectContent position="popper" className="w-[var(--radix-select-trigger-width)] min-w-72">
        {ALERT_ACTION_CATALOG.map((def) => (
          <SelectItem key={def.function} value={def.function} className="py-3 pr-3">
            <div className="flex min-w-0 flex-1 flex-col gap-0.5">
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-baseline gap-2">
                  <span className="font-semibold text-text-default font-body">{def.label}</span>
                  <span className="font-mono text-xs text-text-subtle">{def.function}</span>
                </div>
                <AlertActionBadge status={def.status} label={def.statusLabel} />
              </div>
              <span className="text-xs text-text-muted font-body">{def.description}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default AlertActionSelect;
